import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { boldTextFixLength, standardButtonDisabled } from '@costar/theme-ui';

var baseTab = _objectSpread2(_objectSpread2({
  cursor: 'pointer',
  color: 'white',
  emPaddingY: 'xs-3'
}, boldTextFixLength), {}, {
  '&:hover:not(:disabled):not(.is-selected)': {
    opacity: 1
  },
  '&[disabled]': standardButtonDisabled,
  '&.is-selected': {
    fontWeight: 'bold',
    cursor: 'default',
    bg: 'neutral.subtlest'
  }
});
var cosmosV1 = {
  tabs: {
    bg: 'neutral.lighter',
    px: 'lg',
    height: '2rem',
    borderBottom: 'mediumGray'
  },
  tab: _objectSpread2(_objectSpread2({}, baseTab), {}, {
    py: 'xs-2',
    color: 'text',
    justifyContent: 'center',
    '&.is-selected': {
      fontWeight: 'bold',
      cursor: 'default'
    },
    '&.csg-tui-tab': {
      fontSize: 'xs'
    }
  }),
  indicator: {
    bg: 'accent',
    height: 'tabs.indicator'
  },
  panel: {
    px: 'lg',
    emPaddingY: 'md'
  }
};
var tabs = _objectSpread2(_objectSpread2({}, cosmosV1), {}, {
  'cosmos-v2': _objectSpread2(_objectSpread2({}, cosmosV1), {}, {
    tab: _objectSpread2(_objectSpread2({}, cosmosV1.tab), {}, {
      '&.csg-tui-tab': {
        fontSize: 'sm'
      }
    })
  }),
  'tertiary-inverse': _objectSpread2(_objectSpread2({}, baseTab), {}, {
    tabs: {
      fontSize: 'sm',
      height: '100%',
      //pt: 'xs',
      bg: 'white',
      '.csg-tui-tab-list': {
        ml: 'lg',
        height: '3rem'
      },
      '&:after': {
        content: '" "',
        position: 'absolute',
        bg: 'neutral.medium',
        bottom: '0',
        width: '100%',
        height: '1px',
        zIndex: 0
      }
    },
    tab: _objectSpread2(_objectSpread2({}, baseTab), {}, {
      color: 'text',
      textAlign: 'center',
      justifyContent: 'center',
      emPaddingX: 'lg',
      emPaddingY: 'xs',
      height: '3rem',
      '&.is-selected': {
        fontWeight: 'bold',
        cursor: 'default',
        bg: 'neutral.lighter',
        border: 'neutral.medium',
        borderBottom: '0',
        zIndex: 1
      }
    }),
    indicator: {
      top: '0',
      bg: 'accent',
      height: 'tabs.indicator',
      zIndex: 1
    }
  }),
  verticalNav: {
    tabs: {
      fontSize: 'sm',
      height: '100%',
      emPaddingY: 'unset',
      bg: 'transparent',
      '.csg-tui-tab-list': {
        height: '2rem',
        flexDirection: 'column',
        bg: 'transparent'
      }
    },
    tab: {
      color: 'text',
      emPaddingY: 'xs',
      width: '100%',
      height: '2rem',
      bg: 'transparent',
      justifyContent: 'flex-start',
      textAlign: 'left',
      borderTopRightRadius: 'sm',
      borderBottomRightRadius: 'sm',
      '&.csg-tui-tab': {
        paddingLeft: 'xxl'
      },
      '&:hover:not(:disabled):not(.is-selected)': {
        opacity: 1,
        bg: 'primary.light'
      },
      '&.is-selected': {
        fontWeight: 'bold',
        cursor: 'default',
        bg: 'primary.moderate',
        color: 'white',
        borderBottom: '0',
        zIndex: 1
      }
    },
    indicator: {
      display: 'none'
    },
    panel: {
      width: '100%',
      padding: 'xxl'
    }
  },
  scrollToNav: {
    tabs: {
      fontSize: 'sm',
      height: '100%',
      emPaddingY: 'unset',
      bg: 'transparent',
      '.csg-tui-tab-list': {
        borderLeft: 'neutral',
        height: 'auto',
        flexDirection: 'column',
        bg: 'transparent'
      }
    },
    tab: {
      color: 'text',
      emPaddingY: 'xs',
      width: '100%',
      height: '2rem',
      bg: 'transparent',
      justifyContent: 'flex-start',
      textAlign: 'left',
      borderTopRightRadius: 'sm',
      borderBottomRightRadius: 'sm',
      '&.csg-tui-tab': {
        paddingLeft: 'xxl'
      },
      '&:hover:not(:disabled):not(.is-selected)': {
        opacity: 1,
        bg: 'primary.light',
        cursor: 'pointer'
      },
      '&.is-selected': {
        fontWeight: 'bold',
        cursor: 'default',
        bg: 'transparent',
        color: 'primary.moderate',
        borderBottom: '0',
        borderLeft: 'primary.moderate.thick',
        zIndex: 1
      }
    },
    indicator: {
      display: 'none'
    },
    panel: {
      width: '100%',
      padding: '0'
    }
  }
});

export { tabs };
//# sourceMappingURL=tabs.esm.js.map
